import React, { useState } from "react";
import { useUser } from "../../context/userContext";
import axios from "axios";

const NewsLetterBox = () => {
  const { userData } = useUser();

  const [isContentLoading, setIsContentLoading] = useState(false);

  const initialFormData = {
    name: "",
    email_id: "",
  };

  const [formData, setFormData] = useState(initialFormData);

  const subscribeToNewsletter = async (event) => {
    event.preventDefault();

    try {

      setIsContentLoading(true);

      const response = await axios.post(
        "https://soliboat.solidaridadasia.com/newsletter_subscription",
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userData.token}`,
          },
          withCredentials: true,
        }
      );

      if (response.status === 200) {
        const data = response.data;
        console.log("Response from server:", data);
        alert(data.message[0]);
        setFormData(initialFormData);
      } else {
        console.error("Error subscribing to newsletter:", response.statusText);
      }
    } catch (error) {
      console.error("An unexpected error occurred:", error);
    } finally {
      setIsContentLoading(false);
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  return (
    <>
      {/* Loading screen while API calls are in progress */}
      {isContentLoading && (
        <div className="fixed inset-0 flex flex-col items-center justify-center bg-neutral-50 z-[100]">
          <div className="w-20 h-20 animate-spin">
            <div className="h-full w-full border-4 border-t-dark/50 border-b-dark/80 rounded-[50%]" />
          </div>
          <div className="text-center text-sm lg:text-xl font-medium text-gray-500 mt-8 mx-8 lg:mx-0">
          Please wait while while we process your request{" "}
            <span className="text-xl mx-1 inline-block animate-typing">.</span>
            <span className="text-xl mx-1 inline-block animate-typing">.</span>
            <span className="text-xl mx-1 inline-block animate-typing">.</span>
          </div>
        </div>
      )}
      <div
        className="wow fadeInUp relative z-10 rounded-md bg-primary/[3%] md:mt-6 p-8 dark:bg-primary/10 sm:p-11 lg:p-8 xl:p-11"
        data-wow-delay=".2s"
      >
        <h3 className="mb-4 text-2xl font-bold leading-tight text-black dark:text-white">
          Subscribe to receive future updates
        </h3>
        <p className="mb-11 border-b border-body-color border-opacity-25 pb-11 text-base font-medium leading-relaxed text-body-color dark:border-white dark:border-opacity-25">
          Recieve exciting updates, offers and news, straight from HQ.
        </p>
        <form onSubmit={subscribeToNewsletter}>
          <input
            type="text"
            id="name"
            name="name"
            placeholder="Enter your name"
            value={formData.name}
            onChange={handleInputChange}
            className="mb-4 w-full rounded-md border border-body-color border-opacity-10 py-3 px-6 text-base font-medium text-body-color placeholder-body-color outline-none focus:border-primary focus:border-opacity-100 focus-visible:shadow-none dark:border-white dark:border-opacity-10 dark:bg-[#242B51] focus:dark:border-opacity-50"
          />
          <input
            type="email"
            id="email_id"
            name="email_id"
            placeholder="Enter your email"
            value={formData.email_id}
            onChange={handleInputChange}
            className="mb-4 w-full rounded-md border border-body-color border-opacity-10 py-3 px-6 text-base font-medium text-body-color placeholder-body-color outline-none focus:border-primary focus:border-opacity-100 focus-visible:shadow-none dark:border-white dark:border-opacity-10 dark:bg-[#242B51] focus:dark:border-opacity-50"
          />
          <input
            type="submit"
            value="Subscribe"
            className="duration-80 mb-4 w-full cursor-pointer rounded-md border border-transparent bg-primary py-3 px-6 text-center text-base font-medium text-white outline-none transition ease-in-out hover:bg-opacity-80 hover:shadow-signUp focus-visible:shadow-none"
          />
          <p className="text-center text-base font-medium leading-relaxed text-body-color">
            No spam guaranteed, So please don’t send any spam mail.
          </p>
        </form>
      </div>
    </>
  );
};

export default NewsLetterBox;
